import { trackEcommerce, eventNameConstants, type EcomPromotion } from 'dibs-tracking';

import { getPromoCreative } from '../../helpers/getPromoCreative.js';

type TrackingInput = {
    item: { linkData: { path: string | null } };
    index: number;
};

const getEditorialPromoObj = ({ item, index }: TrackingInput): EcomPromotion => {
    const url = item?.linkData?.path || '';
    const position = index + 1;

    return {
        id: `content-promo-${position}`,
        name: `Content Promo #${position}`,
        creative: getPromoCreative(url),
        position: position,
    };
};

export const trackEditorialImpression = ({ item, index }: TrackingInput): void => {
    trackEcommerce({
        type: 'promotionImpression',
        eventName: eventNameConstants.EVENT_VIEW_PROMOTION,
        promotions: [getEditorialPromoObj({ item, index })],
    });
};

export const trackEditorialClick = ({ item, index }: TrackingInput): void => {
    trackEcommerce({
        type: 'promoClick',
        eventName: eventNameConstants.EVENT_SELECT_PROMOTION,
        promotions: [getEditorialPromoObj({ item, index })],
    });
};
